
import { useState } from "react";
import { Requirement } from "@/types/project";
import { DocumentItem } from "./DocumentItem";
import { DocumentLoading, DocumentEmpty } from "./DocumentStates";
import { useDocuments } from "@/hooks/useDocuments";

interface DocumentsListProps {
  requirement: Requirement;
  projectId: string;
  onRefresh?: () => void;
}

export function DocumentsList({ requirement, projectId, onRefresh }: DocumentsListProps) {
  const { documents, isLoading, refresh, downloadDocument, deleteDocument } = useDocuments(requirement, projectId);
  const [isDeleting, setIsDeleting] = useState<string | null>(null);
  const [expandedDocId, setExpandedDocId] = useState<string | null>(null);

  const handleDownload = async (doc: any) => {
    await downloadDocument(doc);
  };

  const handleDelete = async (doc: any) => {
    try {
      setIsDeleting(doc.id);
      const success = await deleteDocument(doc);
      
      if (success) {
        refresh();
        if (onRefresh) {
          onRefresh();
        }
      }
    } finally {
      setIsDeleting(null);
    }
  };

  if (isLoading) {
    return <DocumentLoading />;
  }

  if (documents.length === 0) {
    return <DocumentEmpty />;
  }

  return (
    <div className="space-y-4">
      {documents.map(document => (
        <DocumentItem
          key={document.id}
          document={document}
          isDeleting={isDeleting}
          expandedDocId={expandedDocId}
          onExpand={setExpandedDocId}
          onDelete={handleDelete}
          onDownload={handleDownload}
        />
      ))}
    </div>
  );
}
